export interface IPhotoReportPhoto {
	name: string;
	path: string;
	number?: number;
	side?: PhotoSide;
	type?: PhotoType;
}

export interface IPhotoReportComplianceMetric {
	score: number;
	comment: string;
	title: string;
}

export type PhotoReportComplianceScore = 1 | 2 | 3;

export const COMPLIANCE_SCORE_COLORS: Map<PhotoReportComplianceScore, string> = new Map([
	[1, '#ff0000'],
	[2, '#E5B60E'],
	[3, '#1AA932'],
]);

export const COMPLIANCE_SCORE_BADGE_KEYS: Map<PhotoReportComplianceScore, string> = new Map([
	[1, 'IMAGE_RECOGNITION.COMPLIANCE_BADGE_LOW'],
	[2, 'IMAGE_RECOGNITION.COMPLIANCE_BADGE_MEDIUM'],
	[3, 'IMAGE_RECOGNITION.COMPLIANCE_BADGE_HIGH'],
]);

export type ComplianceFeedbackRating = 'LIKE' | 'DISLIKE';

export interface IComplianceFeedbackPayload {
	photoreport_id: number;
	rating: ComplianceFeedbackRating;
	comment?: string;
}

export interface IComplianceResultTag {
	color: string;
	text: string;
}

export interface IPhotoReportComplianceResult {
	compliance_score: PhotoReportComplianceScore;
	compliance_comment: string;
	feedback: ComplianceFeedbackRating | null;
	manager_id: number;
	seen: boolean;
	comment?: string | null;
	message_id?: number | null;
	/** @deprecated kept for possible restore of detailed assessment UI */
	photo_quality?: IPhotoReportComplianceMetric;
	empty_gaps?: IPhotoReportComplianceMetric;
	missing_products?: IPhotoReportComplianceMetric;
	extra_products?: IPhotoReportComplianceMetric;
	product_positions?: IPhotoReportComplianceMetric;
	facings?: IPhotoReportComplianceMetric;
	tags?: Array<IComplianceResultTag>;
}

export interface IPhotoreportComplianceStartedEvent {
	user_id: number;
}

export interface IPhotoreportComplianceFinishedEvent {
	compliance_result: IPhotoReportComplianceResult;
	user_id: number;
}

export interface IControlComplianceWsPayload {
	photoreport_id: number | null;
	can_run_compliance_check: boolean;
	compliance_check_block_reason: string | null;
	compliance_check_user_id: number | null;
	compliance_result: IPhotoReportComplianceResult | null;
}

export interface IControlComplianceUpdatedEvent {
	updates: Array<{
		planogram_id: number;
		compliance: IControlComplianceWsPayload | null;
	}>;
}

export enum ComplianceCheckBlockReason {
	LegacyPhotoreport = 'LEGACY_PHOTOREPORT',
	AlreadyHasResult = 'ALREADY_HAS_RESULT',
	AlreadyRunning = 'ALREADY_RUNNING'
}

export interface IPhotoReport {
	id: number;
	can_run_compliance_check: boolean;
	compliance_check_block_reason: ComplianceCheckBlockReason;
	compliance_check_user_id: number;
	compliance_result: IPhotoReportComplianceResult;
	stand_id: number;
	sent_date: string;
	execution_date: string;
	checked_date: string | null;
	returned_date: string | null;
	deadline_date: string | null;
	is_overdue: boolean;
	from: string;
	who: string;
	who_image: string | null;
	comment: string;
	photos: Array<IPhotoReportPhoto>;
	enable_time_tracking: boolean;
	tracked_time: string | null;
	recognition_results: Array<any>;
	chat_message_id: number | null;
}

export enum PhotoSide {
	Front = 'front',
	Back = 'back'
}

export enum PhotoType {
	Recognition = 'RECOGNITION',
	Additional = 'ADDITIONAL'
}
